module.exports = __webpack_public_path__ + "static/media/76.eec0c56.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/76.wav
// module id = +lj6
// module chunks = 0